export default __webpack_public_path__ + "static/media/Awards.4fb16bc1.png";